import { AllSignatories, RequestSignatoresParams } from 'app/common/types/signatores'
import { EmployeeId } from 'app/common/types/id'
import Person from 'app/common/classes/person'
import type { Request } from '../../../index'

type UrlParams = {
  orgId: string
}

export const convertParams = (params: RequestSignatoresParams): [null, UrlParams] => {
  const { orgId } = params
  return [null, { orgId }]
}

export const convertResult = (result: {
  food_responsibles: Array<{
    id: number
    name: { last: string; first: string; middle: string }
  }>
  cafeteria_managers: Array<{
    id: number
    name: { last: string; first: string; middle: string }
  }>
  accountants: Array<{
    id: number
    name: { last: string; first: string; middle: string }
  }>
}): AllSignatories => {
  const {
    food_responsibles: foodResponsibles,
    cafeteria_managers: cafeteriaManagers,
    accountants,
  } = result
  return {
    foodResponsibles: foodResponsibles.map(({ id, name }) => ({
      id: String(id) as EmployeeId,
      person: new Person(name),
    })),
    cafeteriaManagers: cafeteriaManagers.map(({ id, name }) => ({
      id: String(id) as EmployeeId,
      person: new Person(name),
    })),
    accountants: accountants.map(({ id, name }) => ({
      id: String(id) as EmployeeId,
      person: new Person(name),
    })),
  }
}

export const GET_SIGNATORES: Request<RequestSignatoresParams, AllSignatories, UrlParams> = [
  'food/schools/{orgId}/signatories',
  'get',
  ['data'],
]
